class Token {
    constructor (accessToken='', refreshToken='', expiresInSeconds=0, expiration=null) {
        this.accessToken = accessToken
        this.refreshToken = refreshToken

        if (expiration) {
            this.expiration = new Date(expiration)
        } else {
            const now = new Date()
            this.expiration = new Date(now.getTime() + expiresInSeconds * 1000)
        }
    }

    get secondsUntilExpired() {
        let now = new Date()
        if (!this.expiration) {
            return 1000
        }
        let diff = this.expiration.getTime() - now.getTime()
        if (diff <= 0) { return 0 }
        return(Math.floor(diff / 1000))
    }

    get secondsUntilShouldRefresh() {
        if (this.secondsUntilExpired > 10) {
            return this.secondsUntilExpired - 10
        }
        return 0
    }

    get isExpired() {
        return this.secondsUntilExpired < 1
    }

}

export default Token



// WEBPACK FOOTER //
// ./src/models/Token.js